export default __webpack_public_path__ + "static/last_year_7-ee3b48f01a0a6fa6e7fb8d460d99668d.webp";